import { gsap } from 'gsap';

/**
 * Smooth Animated Expand / Collapse Accordions for WatchSight
 * Clean, pure CSS-driven styling without hardcoded inline colors.
 */
export function initAnimatedAccordions() {
  const accordionItems = document.querySelectorAll('.ws-accordion-item');

  accordionItems.forEach((item, index) => {
    const header = item.querySelector('.ws-accordion-header');
    const content = item.querySelector('.ws-accordion-content');

    if (!header || !content) return;

    // Set initial state (open the first item by default, collapse others)
    if (item.classList.contains('active') || index === 0) {
      item.classList.add('active');
      gsap.set(content, { height: 'auto', opacity: 1 });
    } else {
      gsap.set(content, { height: 0, opacity: 0, overflow: 'hidden' });
    }

    header.addEventListener('click', () => {
      const isOpen = item.classList.contains('active');

      // Close all other open accordions for clean single accordion interaction
      accordionItems.forEach(otherItem => {
        if (otherItem !== item && otherItem.classList.contains('active')) {
          otherItem.classList.remove('active');
          const otherContent = otherItem.querySelector('.ws-accordion-content');
          
          if (otherContent) {
            gsap.to(otherContent, {
              height: 0,
              opacity: 0,
              duration: 0.35,
              ease: 'power2.inOut'
            });
          }
        }
      });

      // Toggle clicked item
      if (isOpen) {
        item.classList.remove('active');
        gsap.to(content, {
          height: 0,
          opacity: 0,
          duration: 0.35,
          ease: 'power2.inOut'
        });
      } else {
        item.classList.add('active');
        
        // Auto-calculate height for smooth expansion
        gsap.set(content, { height: 'auto', overflow: 'hidden' });
        const targetHeight = content.offsetHeight;
        gsap.set(content, { height: 0 });

        gsap.to(content, {
          height: targetHeight,
          opacity: 1,
          duration: 0.45,
          ease: 'power3.out',
          onComplete: () => {
            gsap.set(content, { height: 'auto' });
          }
        });
      }
    });
  });
}
